import { toPlainTextSync, extract, Node_Type, Decoration_Type, } from '@wix/ricos';
export var getRichContentFeatures = function (content) {
    var plainTextContent = toPlainTextSync(content);
    var _a = extractRichContentMediaFeatures(content), hasImage = _a.hasImage, hasVideo = _a.hasVideo, hasFile = _a.hasFile, hasLink = _a.hasLink;
    return {
        hasImage: hasImage,
        hasVideo: hasVideo,
        hasFile: hasFile,
        hasLink: containsLink(plainTextContent) || hasLink,
        hasEmail: containsEmailAddress(plainTextContent),
        hasPhoneNumber: containsPhoneNumber(plainTextContent),
        hasInstantMessagingAddress: containsInstantMessagingAddress(plainTextContent),
    };
};
var extractRichContentMediaFeatures = function (content) {
    var hasTextLink = extract(content.nodes)
        .filter(function (_a) {
        var _b;
        var textData = _a.textData;
        return !!((_b = textData === null || textData === void 0 ? void 0 : textData.decorations) === null || _b === void 0 ? void 0 : _b.find(function (d) { return d.type === Decoration_Type.LINK; }));
    })
        .get().length > 0;
    var hasImageLink = extract(content.nodes)
        .filter(function (_a) {
        var _b;
        var imageData = _a.imageData;
        return !!((_b = imageData === null || imageData === void 0 ? void 0 : imageData.link) === null || _b === void 0 ? void 0 : _b.url);
    })
        .get().length > 0;
    return {
        hasLink: hasTextLink || hasImageLink,
        hasImage: extract(content.nodes)
            .filter(function (_a) {
            var type = _a.type;
            return type === Node_Type.IMAGE;
        })
            .get().length > 0,
        hasVideo: extract(content.nodes)
            .filter(function (_a) {
            var type = _a.type;
            return type === Node_Type.VIDEO;
        })
            .get().length > 0,
        hasFile: extract(content.nodes)
            .filter(function (_a) {
            var type = _a.type;
            return type === Node_Type.FILE;
        })
            .get().length > 0,
    };
};
var containsPhoneNumber = function (plainTextContent) {
    // This regexp is taken from https://stackoverflow.com/a/20971688.
    // This seems to be most light weight solution for checking if something
    // similar to phone number exists in provided string. This could result in
    // false positives, but intention here is not to validate number, but rather
    // detect if something like phone number exists. Best solution would be to
    // use something like `libphonenumber`, however it's too big to be used in this
    // utility library.
    // Also. We allow simple numbers from 0 to 99999 to pass this check.
    var possibleNumberSeparators = '-. /\\';
    var phoneNumberRegexp = /(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[-. \\/]?)?((?:\(?\d{1,}\)?[-. \\/]?){0,})(?:[-. \\/]?(?:#|ext\.?|extension|x)[-. \\/]?(\d+))?/gim;
    var matches = plainTextContent.match(phoneNumberRegexp);
    return matches
        ? matches.filter(function (x) {
            var simpleNumberRegexp = /^(\d{1,5})$/gim;
            var trimmed = x.trim();
            return (!!trimmed &&
                !possibleNumberSeparators.includes(trimmed) &&
                !simpleNumberRegexp.test(trimmed));
        }).length > 0
        : false;
};
var containsEmailAddress = function (plainTextContent) {
    // This regexp is taken from https://github.com/manishsaraan/email-validator.
    // There is no guaranteed way to know if string contains valid email,
    // but this is quite good for our case
    var emailAddressRegexp = /[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*(\.[a-zA-Z](-?[a-zA-Z0-9]))?/;
    return emailAddressRegexp.test(plainTextContent);
};
var containsLink = function (plainTextContent) {
    // Concept taken from popular library https://github.com/segmentio/is-url
    var protocolAndDomainLocalRegexp = /(?:\w+:)?\/\/localhost[:?\d]*(?:[^:?\d]\S*)?/;
    var protocolAndDomainNonLocalRegexp = /(?:\w+:)?\/\/[^\s.]+\.\S{2,}/;
    return (protocolAndDomainLocalRegexp.test(plainTextContent) ||
        protocolAndDomainNonLocalRegexp.test(plainTextContent));
};
var containsInstantMessagingAddress = function (plainTextContent) {
    var instantMessagingAddressRegexp = /((q[/]?[q微])|(微信))(([\s]?:[\s]?)|([\s：]))?[0-9]{6,10}/gi;
    return instantMessagingAddressRegexp.test(plainTextContent);
};
//# sourceMappingURL=get-rich-content-features.js.map